import { useEffect, useState } from "react";
import UserProfileService from "../services/userProfileService";

const useUserProfile = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await UserProfileService.getUserProfile();
        setUser(response?.data);
      } catch {
        localStorage.clear();
        window.location.href = "/";
      }
    };

    fetchProfile();
  }, []);

  return user;
};

export default useUserProfile;
